module.exports = __webpack_public_path__ + "img/i-loading.360f3d6b.png";